export default {
  refundRecord_00001: "退款记录",
  refundRecord_00002: "退款日期",
  refundRecord_00003: "退款金额({0})",
}